import styled from 'styled-components'
import { theme } from '../../../../style/theme'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const AutocompleteWrapper = styled.div`
  position: relative;
  font-size: 1rem;
`
AutocompleteWrapper.displayName = 'AutocompleteWrapper'

export const AutocompleteItems = styled.div`
  transition: all 1s ease-in-out;
  position: absolute;
  width: 100%;
  z-index: 2;
  background: ${colorTheme.input.autocomplete.background};
  border-radius: 0.75em;
  top: 4.44em;
  max-height: 17em;
  overflow-y: auto;
  box-shadow: 0 1em 2.5em ${colorTheme.input.autocomplete.shadow};
  padding: 0.75em;

  &.error {
    top: 6.44em;
  }
`
AutocompleteItems.displayName = 'AutocompleteItems'

export const AutoCompleteItem = styled.div`
  display: grid;
  gap: 0.13em;
  background: ${colorTheme.input.autocomplete.background};
  padding: 1em 0.75em;
  border: 1px solid transparent;
  border-top-color: ${colorTheme.input.autocomplete.item.border};
  color: ${colorTheme.input.autocomplete.item.text};
  cursor: pointer;

  &:last-child {
    border-bottom-color: ${colorTheme.input.autocomplete.item.border};
  }

  &.active {
    border-color: ${colorTheme.input.autocomplete.item.active.border};
    border-radius: 0.63em;

    + div {
      border-top: 1px solid transparent;
    }
  }
`
AutoCompleteItem.displayName = 'AutoCompleteItem'

export const AutoCompleteNoItems = styled.div`
  font-family: ${theme.fontRobotoRegular};
  font-size: 1em;
  color: ${colorTheme.input.autocomplete.item.active.text};
`
AutoCompleteNoItems.displayName = 'AutoCompleteNoItems'
